import script from "./recordNav.vue?vue&type=script&setup=true&lang=js"
export * from "./recordNav.vue?vue&type=script&setup=true&lang=js"

import "./recordNav.vue?vue&type=style&index=0&id=66eadc0d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66eadc0d"]])

export default __exports__